export default "__VITE_ASSET__d56a3e60__"